import React from 'react';
import Main from './Main';

const Home = () => (
  <div>
    <Main />
  </div>
);

export default Home;
